import React, { useEffect, createElement } from 'react';
import { useLocation } from 'react-router-dom';
const PIXEL_ID = '1199364765653385';
let pixelInitialized = false;
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const FacebookPixel = () => {
  const location = useLocation();
  useEffect(() => {
    if (pixelInitialized) return;
    // Standard Meta Pixel base code
    const f = window;
    const b = document;
    const e = 'script';
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = b.getElementsByTagName(e)[0];
    s?.parentNode?.insertBefore(t, s);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
    pixelInitialized = true;
  }, []);
  // Track page views on route change
  useEffect(() => {
    if (pixelInitialized && window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname]);
  return null;
};
export default FacebookPixel;